import styled, { css } from 'styled-components';
import { CARD_MIN_HEIGHT, OVERLAY_WIDTH } from '@/app/components/search/components/Card/constants.ts';
import { loadAnimation } from '../../../styles/mixins';

import { imageWidthStyle } from '../utils/styled';

export const OVERLAY_CARD_IMAGE_HEIGHT = 176;

export const imageRoundingStyles = css<{ isOverlay?: boolean }>`
  ${({ isOverlay }) => {
    if (isOverlay) {
      return css`
        border-radius: 8px;
      `;
    }

    return css`
      border-radius: 8px;
    `;
  }};
`;

const imageLoaderOverlayDesktopStyles = css`
  width: ${OVERLAY_WIDTH} !important;
  height: ${OVERLAY_CARD_IMAGE_HEIGHT}px !important;
  min-height: ${OVERLAY_CARD_IMAGE_HEIGHT}px !important;
`;

const imageLoaderOverlayMobileStyles = css`
  width: 104px;
  min-height: 110px;
`;

const imageLoaderMobileStyles = css`
  min-height: 160px;
`;

export const ImageLoader = styled.div<{ isOverlay: boolean }>`
  width: 100%;
  min-height: 200px;
  position: relative;
  background-size: 800px 104px;
  ${imageWidthStyle};
  ${loadAnimation};
  ${imageRoundingStyles};

  @media (max-width: 767px) {
    ${({ isOverlay }) => (isOverlay ? imageLoaderOverlayMobileStyles : imageLoaderMobileStyles)}
  }

  @media (min-width: 768px) {
    min-height: ${CARD_MIN_HEIGHT};
    flex-shrink: 0;
    ${({ isOverlay }) => isOverlay && imageLoaderOverlayDesktopStyles};
  }
`;

const desktopContainer = css`
  ${imageWidthStyle};
`;

const desktopContainerOverlay = css`
  @media (min-width: 768px) {
    width: ${OVERLAY_WIDTH};
    min-width: ${OVERLAY_WIDTH};
    height: ${OVERLAY_CARD_IMAGE_HEIGHT}px;
    max-height: 200px;
  }
`;

const mobileOverlay = css`
  width: 104px;
  height: unset;
`;

const debugStyles = css`
  border-radius: 8px 8px 0 0;
`;

const noImageStyles = css`
  background-color: ${({ theme }) => theme.kallisto.color.common.black[50]};
`;

export const GalleryContainer = styled.div<{
  itemsLength: number;
  isOverlay: boolean;
  debugEnabled: boolean;
  noImage: boolean;
  ref: (node: Element) => void;
}>`
  display: flex;
  flex: none;
  flex-flow: row nowrap;
  position: relative;
  width: 100%;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  border-radius: 8px;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ${imageRoundingStyles};

  ${({ debugEnabled }) => debugEnabled && debugStyles};
  ${({ noImage }) => noImage && noImageStyles};

  @media (max-width: 767px) {
    ${({ isOverlay }) => isOverlay && mobileOverlay};
  }

  @media (min-width: 768px) {
    ${({ isOverlay }) => (isOverlay ? desktopContainerOverlay : desktopContainer)};
  }

  ${({ itemsLength }) =>
    itemsLength > 1
      ? css`
          overflow: auto;
        `
      : css`
          overflow: hidden;
        `};

  &::-webkit-scrollbar {
    display: none;
  }

  &::after {
    content: '';
    padding-right: 0.02px;
  }
`;

export const TshLogo = styled.img`
  position: absolute;
  left: calc(50% - 55.5px);
  top: calc(50% - 45px);
  z-index: 2;
  pointer-events: none;
`;

export const TshBackdrop = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(60, 60, 60, 0.5);
  opacity: 0.2;
  border-radius: 8px 0px 0px 8px;
  z-index: 1;
  pointer-events: none;
`;

export const CloseButtonContainer = styled.button<{ isDark: boolean; isSmall: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
  border: 0;
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  transition: transform 0.2s ease-in-out;
  user-select: none;

  &:hover {
    background-color: rgba(255, 255, 255, 1);
    box-shadow: ${({ theme }): string => theme?.kallisto?.shadow?.mediumDownShadow};

    svg {
      padding: 0;
    }
  }

  ${({ isSmall }) =>
    isSmall
      ? css`
          width: 24px;
          height: 24px;
          margin: 8px;

          &:hover {
            background-color: rgba(60, 60, 60, 0.8);
            width: 26px;
            height: 26px;
            margin: 7px;
          }

          svg,
          img {
            width: 14px;
            height: 14px;
          }
        `
      : css`
          width: 30px;
          height: 30px;
          margin: 12px;

          &:hover {
            width: 32px;
            height: 32px;
            margin: 11px;
          }

          svg,
          img {
            width: 16px;
            height: 16px;
          }
        `}

  ${({ isDark }) =>
    isDark &&
    css`
      background-color: rgba(60, 60, 60, 0.5);

      &:hover {
        background-color: rgba(60, 60, 60, 0.8);
      }
    `}
`;
